<template>
  <v-card class="mx-auto">
    <v-card-title>OB-Gyne History</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col>
            <h3>Menstrual History</h3>
            <v-radio-group v-model="formData.ob_gyne.is_applicable">
              <v-radio value="Y">
                <template v-slot:label>
                  <div>Applicable</div>
                </template>
              </v-radio>
              <v-radio value="N">
                <template v-slot:label>
                  <div>Not Applicable</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" md="4">
            <v-menu
              v-if="formData.ob_gyne.is_applicable === 'Y'"
              v-model="lmp"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computedDateFormatted"
                  label="Last menstrual period"
                  placeholder="YYYY-MM-DD"
                  hint="YYYY-MM-DD Format"
                  persistent-hint
                  outlined
                  readonly
                  clearable
                  v-on="on"
                  :rules="[v => !!v || 'Last menstrual period is required']"
                ></v-text-field>
              </template>
              <v-date-picker v-model="formData.ob_gyne.lmp" no-title @input="lmp = false"></v-date-picker>
            </v-menu>
          </v-col>

        </v-row>

        <v-row v-if="formData.ob_gyne.is_applicable === 'Y'">
          <v-col>
            <h3>Pregnancy History</h3>
            <v-row>
              <v-col>
                <v-text-field
                  placeholder="Gravidity (No. of pregnancy)"
                  type="number"
                  outlined
                  v-model="formData.ob_gyne.gravidity"
                  :rules="[v => !!v || 'Gravidity is required']"
                  label="Gravidity (No. of pregnancy)"
                  required
                />
              </v-col>
              <v-col>
                <v-text-field
                  placeholder="Parity (No. of delivery)"
                  type="number"
                  outlined
                  v-model="formData.ob_gyne.parity"
                  :rules="[v => !!v || 'Parity is required']"
                  label="Parity (No. of delivery)"
                  required
                />
              </v-col>
              <v-col>
                <v-text-field
                  placeholder="No. of full term pregnancy"
                  type="number"
                  outlined
                  v-model="formData.ob_gyne.full_term"
                  :rules="[v => !!v || 'Full term is required']"
                  label="No. of full term pregnancy"
                  required
                />
              </v-col>
            </v-row>
            <v-row>

              <v-col>
                <v-text-field
                  placeholder="No. of premature pregnancy"
                  type="number"
                  outlined
                  v-model="formData.ob_gyne.premature"
                  :rules="[v => !!v || 'Premature is required']"
                  label="No. of premature pregnancy"
                  required
                />
              </v-col>
              <v-col>
                <v-text-field
                  placeholder="No. of abortion"
                  type="number"
                  outlined
                  v-model="formData.ob_gyne.abortion"
                  :rules="[v => !!v || 'Abortion is required']"
                  label="No. of abortion"
                  required
                />
              </v-col>
              <v-col>
                <v-text-field
                  placeholder="No. of living children"
                  type="number"
                  outlined
                  v-model="formData.ob_gyne.living_children"
                  :rules="[v => !!v || 'Last name is required']"
                  label="No. of living children"
                  required
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="currentTab === 0"
        @click="backTab"
        color="info"
        class="mr-4">
        BACK
      </v-btn>
      <v-btn
        :disabled="!valid"
        @click="validate"
        color="success"
        class="mr-4">
        NEXT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    export default {
        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                valid: false,
                dateFormatted: this.formatDate(this.formData.ob_gyne.lmp),
                lmp: false,
            }
        },

        computed: {
            computedDateFormatted: {
                get() {
                    return this.parseDate(this.formData.ob_gyne.lmp);
                },
                set(value) {
                    this.formData.ob_gyne.lmp = value;
                },
            },
        },

        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.formData.ob_gyne.lmp)
            },
        },

        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true;
                    this.$bus.emit('nextTab', this.currentTab + 1);
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            },

            formatDate(date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`
            },
            parseDate(date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
    }
</script>

<style scoped>

</style>
